import axios from "axios";
import { del, get, post, patch,  put } from "./titles_api_helper";
import * as url from "./titles_url_helper";





// Get features
export const getTitles = () => get(url.GET_TITLES);


// Add feature
//export const addNewFeature = feature => post(url.ADD_NEW_ACTION, feature);
//export const addNewBranch = branch => post(url.ADD_NEW_BRANCH, JSON.stringify(branch));

export const addNewTitle = title => post(url.ADD_NEW_TITLE, title, {
    headers: { "Content-Type": "application/json" }
  });



// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateTitle = title => patch(`${url.UPDATE_TITLE}/${title.id}`,  title);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteTitle = title => del(`${url.DELETE_TITLE}/${title.id}`);







export {
  //getLoggedInUser,
  
  
};
